<template>
  <div cols="12" sm="12" class="container-prop-component">
    <v-select
      :disabled="readonly"
      :items="vSelectItems"
      :label="$t(name)"
      v-model="localValue"
      multiple
      :hint="$t(schema.hint)"
      persistent-hint
      dense
      filled
      @change="$emit('change', localValue)"
    >
    </v-select>
  </div>
</template>
<script>
export default {
  name: 'dr-property-multiple-select',
  props: ['schema', 'value', 'readonly'],
  inject: ['stateName'],
  data() {
    return {
      name: ''
    }
  },

  computed: {
    vSelectItems() {
      if (this.innerSchema?.computed) {
        return this.schema.computed(this)
      }

      return this.innerSchema?.items
    },
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  created() {
    this.innerSchema = this.schema
    if (this.innerSchema.onCreate) {
      this.innerSchema.onCreate(this)
    }
    this.name = this.innerSchema.name
  }
}
</script>
